import styled from "styled-components";
/*
interface BackgroundProps {
    show?: boolean;
}

 export const Background = styled.div<BackgroundProps>`
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: ${(props) => (props.show ? "flex" : "none")};

    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
*/
export const Background = styled.div<{ show: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: ${({ show }) => (show ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    z-index: 1000; // Garante que fique acima de outros elementos
    backdrop-filter: blur(4px);
    transition: opacity 0.3s ease-in-out;
`;

export const PopupContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    min-width: 300px;
`;

export const Message = styled.p`
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`;

export const ConfirmButton = styled.button`
    background-color: #14b8a6;
    color: white;
    font-weight: bold;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
        background-color: #0f766e;
    }
`;

export const CancelButton = styled.button`
    background-color: #ef4444;
    color: white;
    font-weight: bold;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
        background-color: #b91c1c;
    }
`;
